import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PROMOTE_WALLET_PAYMENT_PRIMARY_EXPERIMENT = defineFcm('promote_wallet_payment_primary_experiment')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				experimentName: { type: 'string' },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-koi',
		scope: 'corgi-front-end',
		context: 'Promote Page',
		description: 'Controls the experiment for promoting wallet payment as the primary CTA on the promote page',
		import: false,
		template: {
			experimentName: '',
		},
	});
